import { render } from "./Catalog.vue?vue&type=template&id=c622433e&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=c622433e&lang=css"
import "./Catalog.vue?vue&type=style&index=1&id=c622433e&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c622433e"]])

export default __exports__